export default __webpack_public_path__ + "static/media/3.72a6c46d.jpg";